import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'Does laser therapy hurt?',
    a: 'Most patients describe a gentle, soothing warmth. It should not feel painful.'
  }, {
    q: 'How long does a laser therapy session take?',
    a: 'Many sessions are brief, but timing depends on the area being treated and the care plan.'
  }, {
    q: 'How many visits will I need?',
    a: 'It depends on whether the issue is acute, chronic, or recurring. Paragon Chiropractic will recommend a plan after evaluation.'
  }, {
    q: 'Can laser therapy be combined with chiropractic care?',
    a: 'Yes. Laser therapy is often used alongside chiropractic adjustments, massage therapy, decompression, stretching, strengthening, and other supportive care when appropriate.'
  }, {
    q: 'Is laser therapy drug-free and non-surgical?',
    a: 'Yes. Laser therapy is non-invasive and does not involve medication or surgery.'
  }, {
    q: 'What conditions do patients commonly ask about?',
    a: 'Patients often ask about back pain, neck pain, arthritis, plantar fasciitis, tendonitis, bursitis, carpal tunnel, sciatica, sports injuries, and soft-tissue pain.'
  }, {
    q: 'Will insurance cover laser therapy?',
    a: 'Coverage varies. Paragon Chiropractic can explain payment options and whether package pricing is available.'
  }, {
    q: 'How do I get started?',
    a: 'Submit the form or call (248) 590-2195 to request a laser therapy consultation.'
  }];
  return <section className="py-20 md:py-24 bg-white" data-id="element-43">
      <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 max-w-2xl mx-auto" data-id="element-45">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-brand-navy mb-5 leading-tight" data-id="element-46">
            Frequently Asked Questions
          </h2>
          <p className="text-base md:text-lg text-gray-700" data-id="element-47">
            Common questions about Aspen laser therapy at Paragon Chiropractic.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.05
        }} className="border-2 border-gray-200 hover:border-brand-teal/40 rounded-xl overflow-hidden bg-white shadow-sm transition-colors duration-300" data-id="element-49">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-50">
                <span className="text-base md:text-lg font-black text-brand-navy pr-4 leading-tight" data-id="element-51">
                  {faq.q}
                </span>
                {openIndex === idx ? <ChevronUpIcon className="w-6 h-6 text-brand-teal flex-shrink-0" data-id="element-52" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-53" />}
              </button>

              <AnimatePresence data-id="element-54">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-55">
                    <div className="px-6 pb-6 text-gray-700 leading-relaxed text-sm md:text-base border-t border-gray-100 pt-4" data-id="element-56">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}